<template>
  <VModal name="party-update-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('envelope.party.updateParty') }}</h2>
    </template>
    <template v-slot:content>
      <VForm
        v-if="canUpdateParty === true"
        :onSubmit="validateForm"
        data-vv-scope="party-edit"
        ref="form"
        :loading="loading">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="12">
              <b>{{ $t('envelope.party.emailAddress') }}</b>
              <VInput
                type="text"
                :class="{ 'a-input--error': errors.has('party-edit.email') }"
                placeholder="e.g. jo.bloggs@example.com"
                v-validate="'required|isTrimmedEmail'"
                data-vv-name="email"
                data-vv-as="email"
                data-vv-delay="1000"
                v-model.trim="party.email"
                data-ec="update_envelope_party_modal"
                data-et="email_input"
                data-vv-scope="party-edit"
                data-hj-suppress
              />
              <VMessage type="error" subtype="basic" v-show="errors.has('party-edit.email')">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('party-edit.email') }}
                </template>
              </VMessage>
            </div>
          </VGrid>
        </div>
        <div slot="row" v-if="errorMessage">
          <VMessage type="error" subtype="basic">
            <template v-slot:icon>
              <LifeRingIcon />
            </template>
            <template v-slot:text>
              {{ errorMessage }}
            </template>
          </VMessage>
        </div>
        <div slot="formButtons" type="right">
          <VButton
            type="cta-1"
            subtype="submit"
            class="float-right"
            href="#"
            data-ec="update_envelope_party_modal"
            data-et="update_party_button">
            <CheckIcon />
            <span>{{ $t('envelope.party.updateParty') }}</span>
          </VButton>
        </div>
      </VForm>
      <VMessage type="warning" subtype="basic" v-else>
        <template v-slot:icon>
          <ExclamationTriangleIcon />
        </template>
        <template v-slot:text>
          {{ $t('envelope.party.messageCanNoLongerUpdate') }}
        </template>
      </VMessage>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { CheckIcon, ExclamationTriangleIcon, LifeRingIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'UpdatePartyModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    envelope: {
      type: [Object],
      required: true,
    },
    party: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VButton,
    VInput,
    VMessage,
    VForm,
    VGrid,
    VModal,
    CheckIcon,
    XMarkIcon,
    LifeRingIcon,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
    };
  },
  computed: {
    canUpdateParty() {
      if (!this.party.status) return false;

      const envelopeStatus = this.envelope.status;
      if (envelopeStatus === 'sent' || envelopeStatus === 'draft') {
        const status = this.party.status.computed_status;

        if (['unsent', 'unsentDraft', 'queued', 'unsentAwaiting', 'sent', 'bounced'].includes(status)) return true;
      }
      return false;
    },
  },
  methods: {
    onCloseModal() {
      const scope = this.$refs.form.$el.getAttribute('data-vv-scope');
      this.errors.clear(scope);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.party.fingerprint = this.$route.params.envelopeFingerprint;
          this.$store.dispatch('envelopes/UPDATE_PARTY', this.party).then(() => {
            this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('envelope.party.successfullyUpdatedMessage'), icon: 'check', type: 'success' }));
          }).finally(() => {
            this.$store.dispatch('envelopes/GET_ENVELOPE', { fingerprint: this.party.fingerprint }).finally(() => {
              this.$bus.$emit('closeModal');
              this.loading = false;
            });
          });
        }
      });
    },
  },
};
</script>
